
import { Component, Input } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { interval, Subscription } from 'rxjs';
import { AuthService } from 'src/app/Core/auth/services/auth/auth.service';
import { Breadcrumb } from 'src/app/Shared/_models/breadcrumb.model';
import { AnalyticsService } from 'src/app/Shared/_services/analytics/analytics.service';
import { BreadCrumbsComponent } from 'src/app/Shared/components/bread-crumbs/bread-crumbs.component';
import { ToastService } from 'src/app/Shared/services/toast/toast.service';

// Removed: getCurrentLngData, getPageData - migrated to ngx-translate
@Component({
    selector: 'app-buyer-confirm-email',
        standalone: true,
templateUrl: './buyer-new-confirm-email.component.html',
    styleUrls: ['./buyer-new-confirm-email.component.scss'],
    imports: [BreadCrumbsComponent, TranslatePipe]
})
export class BuyerConfirmEmailComponent {
  email!: any;
  resend_clicked = false;breadcrumbItems: Breadcrumb[] = [];
  @Input() userEmail: string = '';
  isResending: boolean = false;
  showSuccess: boolean = false;
  countdownActive: boolean = false;
  countdown: number = 60;
  countdownSubscription: Subscription | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private toastService: ToastService,
    private titleService: Title,
    private translate: TranslateService,
    private analyticsService: AnalyticsService
  ) {
    this.titleService.setTitle('Bid X Sell | Confirm Email');

    this.route.queryParams.subscribe((params) => {
      if (params['email']) {
        this.email = params['email'];
      } else {
        this.router.navigate(['/buyer/auth/login']);
      }
    });
  }resendCode() {
    this.toastService.clear();

    this.resend_clicked = true;
    if (this.countdownActive) return;
    this.isResending = true;
    this.authService.resendEmailVerification(this.email).subscribe({
      next: () => {
        this.resend_clicked = false;
        this.isResending = false;
        this.showSuccess = true;
        this.startCountdown();
        setTimeout(() => {
          this.showSuccess = false;
        }, 5000);
        // Track email verification sent
        // this.analyticsService.trackEmailVerification('sent', 'buyer');
      },
      error: (error) => {
        this.resend_clicked = false;

        this.toastService.showError(error?.error?.Error[0]);
      },
    });
  }

  startCountdown(): void {
    this.countdown = 60;
    this.countdownActive = true;

    if (this.countdownSubscription) {
      this.countdownSubscription.unsubscribe();
    }

    this.countdownSubscription = interval(1000).subscribe(() => {
      this.countdown--;

      if (this.countdown <= 0) {
        this.countdownActive = false;
        this.countdownSubscription?.unsubscribe();
      }
    });
  }

  getCountdownText(): string {
    return `${this.translate.instant('buyer_confirm_email.buyer_verify_mail_resend_mail_message')} ${this.countdown} ${this.translate.instant('buyer_confirm_email.buyer_verify_mail_resend_seconds')}`;
  }
}
